export default __webpack_public_path__ + "static/media/p-4-mobile.7404caeb.png";